import { Link } from 'react-router-dom';
import { getDocsByGroup, type DocGroupId } from '../content/docs';

const ORDER: DocGroupId[] = ['overview', 'contact', 'shared', 'server', 'pipeline'];

export default function Docs() {
  const groups = getDocsByGroup();
  const total = ORDER.reduce((n, g) => n + groups[g].docs.length, 0);

  return (
    <div className="page docs-index">
      <h2>Documentation</h2>
      <p>
        Reference documentation for the Synergy Platform integration estate. Pages are
        rebuilt from <code>../docs/</code> markdown and <code>src/&lt;workflow&gt;/workflow.json</code>
        whenever the source changes.
      </p>

      {total === 0 && (
        <p className="note">
          No documentation found. Run <code>npm run prepare-docs</code> to copy markdown
          from <code>../docs/</code> into <code>src/content/docs/</code>.
        </p>
      )}

      {ORDER.map((g) => {
        const group = groups[g];
        if (!group.docs.length) return null;
        return (
          <section key={g} className="docs-group">
            <h3>{group.label}</h3>
            <div className="docs-card-grid">
              {group.docs.map((d) => (
                <Link key={d.slug} to={`/docs/${d.slug}`} className="docs-card">
                  <h4>{d.title}</h4>
                  {d.description && <p>{d.description}</p>}
                </Link>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
